import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import TablaGrillas from 'views/Grillas/QuerysGrilla';

function Querys() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardHeader>
          <Typography variant="h6" fontWeight="bold" color="text.primary">
            Consultas del Sistema
          </Typography>
          <Divider sx={{ mt: 1 }} />
        </CardHeader>
        <CardBody>
          <TablaGrillas />
        </CardBody>
      </Card>
    </Box>
  );
}

export default Querys;
